/*
* 数据分析
* */

const DaStudent = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaStudent.vue')
const DaTeacher = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaTeacher.vue')
const DaClassRoom = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaClassRoom.vue')
const DaOptional = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaOptional.vue')
const DaAchievement = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaAchievement.vue')
const AchievementAnalysis = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/components/AchievementAnalysis.vue')
const DaVenue = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaVenue.vue')
const DaCourse = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaCourse.vue')
const DaAttendance = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaAttendance.vue')
const DaMoral = () => import( /* webpackChunkName: "dataAnalysis" */ '@/pages/dataAnalysis/views/DaMoral.vue')

const dataAnalysis = [
  {
    path: 'daStudent',
    name: 'daStudent',
    component: DaStudent,
  },
  {
    path: 'daTeacher',
    name: 'daTeacher',
    component: DaTeacher,
  },
  {
    path: 'daClassRoom',
    name: 'daClassRoom',
    component: DaClassRoom,
  },
  {
    path: 'daCourse',
    name: 'daCourse',
    component: DaCourse,
  },
  {
    path: 'daAchievement',
    name: 'daAchievement',
    component: DaAchievement,
  },
  {
    path: 'achievementAnalysis',
    name: 'achievementAnalysis',
    component: AchievementAnalysis,
  },
  {
    path: 'daVenue',
    name: 'daVenue',
    component: DaVenue,
  },
  {
    path: 'daOptional',
    name: 'daOptional',
    component: DaOptional,
  },
  {
    path: 'daAttendance',
    name: 'daAttendance',
    component: DaAttendance,
  },
  {
    path: 'daMoral',
    name: 'daMoral',
    component: DaMoral,
  },

]
export default dataAnalysis;
